import {createSlice} from '@reduxjs/toolkit';

import type {DefaultRootState} from 'react-redux';

const initialState = {
  settings: {isHidingDataAccessInfoBox: false},
};

export const sweetaiSlice = createSlice({
  name: 'sweetai',
  initialState,
  reducers: {
    toggleIsHidingDataAccessInfoBox: (state) => {
      state.settings.isHidingDataAccessInfoBox =
        !state.settings.isHidingDataAccessInfoBox;
    },
  },
});

export const selectIsHidingDataAccessInfoBox = (state: DefaultRootState) =>
  state.sweetai.settings.isHidingDataAccessInfoBox;

export const {toggleIsHidingDataAccessInfoBox} = sweetaiSlice.actions;
